import { FC } from "react";

import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import TextControl from "apps/website/components/base/Text/TextControl/TextControl";
import Spacer from "apps/website/components/layout/Spacer/Spacer";
import { themeRootClassMap } from "apps/website/maps/Theme.map";
import { ISummaryDetailFreshSprinkles } from "@forms/schema";

import { SummaryTD, SummaryTH } from "../table/SummaryTableElements";

interface ISummaryDetailedPricing {
  totalTodayNotDiscounted?: number;
  totalTodayDiscounted?: number;
  chickenSprinklesData?: ISummaryDetailFreshSprinkles;
  deliveryPrice?: number;
  freshMealPlanPricePerPortion?: string;
}

const SummaryDetailedPricing: FC<ISummaryDetailedPricing> = ({
  totalTodayNotDiscounted,
  totalTodayDiscounted,
  chickenSprinklesData,
  deliveryPrice,
  freshMealPlanPricePerPortion,
}) => (
  <tr>
    <SummaryTH className="align-top">
      <TextControl size={2}>Total today</TextControl>
    </SummaryTH>
    <SummaryTD className="flex flex-col items-end">
      <div>
        <TextBody tag="s" size={2}>
          £{ (
            (totalTodayNotDiscounted ?? 0) +
            (chickenSprinklesData?.savings ?? 0) +
            (deliveryPrice ?? 0)
          )?.toFixed(2) }
        </TextBody>
          &nbsp;
        <TextControl tag="span" size={2}>
            £{ totalTodayDiscounted?.toFixed(2) }
        </TextControl>
      </div>
      <Spacer size="sm" />
      <div
        data-theme="light-grey"
        className={`rounded-full w-fit px-2 py-1 ${themeRootClassMap["light-grey"]}`}
      >
        { freshMealPlanPricePerPortion } / meal
      </div>
    </SummaryTD>
  </tr>
);

export default SummaryDetailedPricing;
